import React from "react";

// External
import { Delaunay } from "d3-delaunay";

const Voronoi = ({ dim, currentProjection, data, scale, margin, actions }) => {
  const { geoXScale, geoYScale, tsneXScale, tsneYScale } = scale;
  const { containerWidth, windowHeight } = dim;
  const points = data.map(el => {
    let x = 0,
      y = 0;
    if (currentProjection === "geo") {
      x = geoXScale(el.x_geo);
      y = geoYScale(el.y_geo);
    } else {
      x = tsneXScale(el.x_tsne);
      y = tsneYScale(el.y_tsne);
    }
    return [x, y];
  });

  const delaunay = Delaunay.from(points);
  const voronoi = delaunay.voronoi([0, 0, containerWidth, windowHeight]);

  return (
    <g className="voronoi">
      {points.map((pt, i) => (
        <g className="clipPathCircles" key={`voronoiClip${i}`}>
          <clipPath className="clipCircle" id={`circle${i}`}>
            <circle cx={pt[0]} cy={pt[1]} r={50} />
          </clipPath>
          <path
            key={`voronoiCell${i}`}
            className="voronoiCell"
            clipPath={`url(#circle${i})`}
            d={voronoi.renderCell(i)}
            opacity="0.5"
            fill="transparent"
            onMouseEnter={() =>
              actions.hoverCountry(
                data[i].country,
                data[i].membershipCount,
                pt[0],
                pt[1]
              )
            }
            onMouseLeave={() =>
              actions.hoverCountry(undefined, undefined, undefined, undefined)
            }
          />
        </g>
      ))}
    </g>
  );
};

export default Voronoi;
